// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"0ec83025","81":"e0179636","223":"544ef5df","325":"e8f34fa8","495":"9538213d","682":"e68029ab","967":"289c7f3d"}[chunkId] + ".chunk.js";
};